// extracted by mini-css-extract-plugin
export default {"app-footer":"Footer_app-footer__Wh+9e","link":"Footer_link__yvgti","footer-link-container":"Footer_footer-link-container__NnEc8","footer-text":"Footer_footer-text__VEdls"};